var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.5,
    height: 21.5,
    viewBox: "0 0 21.5 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_49795",
    "data-name": "Group 49795",
    transform: "translate(-1228 -80.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_433",
    "data-name": "Ellipse 433",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(1228.75 81.25)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_608",
    "data-name": "Line 608",
    y2: 5.455,
    transform: "translate(1238.75 85.796)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_609",
    "data-name": "Line 609",
    x2: 3.636,
    y2: 3.636,
    transform: "translate(1238.75 91.25)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.e96c0c41133a5f512902ea74a8ac27f9.svg";
export { ForwardRef as ReactComponent };